import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import { useFootballContext } from "../../../state/football-play/context";
import { REPLAY_SPEEDS } from "./utils/useDriveReplay";
import driveReplayDialogStyles from "../styles/DriveReplayDialog.styles";

/**
 * Transport for drive replay: restart, step, pause and playback speed. Prev and
 * next pause the walk (see setReplayIndex) so a crew can hold on a play.
 */
const DriveReplayControls = ({ replay }) => {
	const classes = driveReplayDialogStyles();
	const {
		setReplayIndex,
		restartDriveReplay,
		stopDriveReplay,
		toggleReplayPlaying
	} = useFootballContext();

	if (!replay.active) {
		return null;
	}

	const { index, count, playing, speed, setSpeed } = replay;

	return (
		<Box className={classes.transport}>
			<Button size="small" variant="outlined" onClick={restartDriveReplay}>
				Restart
			</Button>
			<Button
				size="small"
				variant="outlined"
				className={classes.transportButton}
				disabled={index === 0}
				onClick={() => setReplayIndex(index - 1)}
			>
				Prev
			</Button>
			<Button
				size="small"
				variant="outlined"
				className={classes.transportPrimary}
				onClick={toggleReplayPlaying}
			>
				{playing ? "Pause" : "Play"}
			</Button>
			<Button
				size="small"
				variant="outlined"
				className={classes.transportButton}
				disabled={index >= count - 1}
				onClick={() => setReplayIndex(index + 1)}
			>
				Next
			</Button>
			<Button size="small" variant="outlined" onClick={stopDriveReplay}>
				Close
			</Button>

			<Box className={classes.transportSpeed}>
				<Typography variant="caption" color="textSecondary">
					Speed
				</Typography>
				<Select
					value={speed}
					onChange={(e) => setSpeed(Number(e.target.value))}
					inputProps={{ "aria-label": "Playback speed" }}
				>
					{REPLAY_SPEEDS.map(({ label, value }) => (
						<MenuItem key={label} value={value}>
							{label}
						</MenuItem>
					))}
				</Select>
			</Box>
		</Box>
	);
};

export default DriveReplayControls;
